<template>
<div class="page page_hezuo">
    <div class="bg">欢迎加入时代记忆城市合伙人大家庭</div>
    <!-- 基本信息 -->
    <div>
        <div class="step">
            <!-- 进行状态 加active类 ; 非进行状态 不加-->
            <div class="step_item active">
                <div class="step_name">填写信息</div>
                <div class="step_icon">
                    <div class="icon"></div>
                </div>
            </div>
            <div class="step_item">
                <div class="step_name">审核</div>
                <div class="step_icon">
                    <div class="icon"></div>
                </div>
            </div>
            <div class="step_item">
                <div class="step_name">成功入驻</div>
                <div class="step_icon">
                    <div class="icon"></div>
                </div>
            </div>
        </div>
        <!-- 表单 -->
        <div class="form_wrap">
            <div class="item flex" @click="areaPicker=true">
                <div class="item_l">
                    <div class="title">省市区</div>
                    <van-field v-model="area" placeholder="请选择" />
                </div>
                <div class="item_r" @click="areaPicker=true">选择</div>
            </div>
            <div class="item">
                <div class="title">详细信息</div>
                <div class="name">
                    <van-field v-model="street" placeholder="如道路、门牌号、小区、楼栋号等" />
                </div>
            </div>
            <div class="item">
                <div class="title">企业名称</div>
                <div class="name">
                    <van-field v-model="company" placeholder="请填写企业名称" />
                </div>
            </div>
            <div class="item">
                <div class="title">机构代码</div>
                <div class="name">
                    <van-field v-model="companyCode" placeholder="请填写企业机构代码" />
                </div>
            </div>
            <div class="item">
                <div class="title">上传个体工商户营业执照</div>
                <div class="upload_images">
                    <!-- 示例图片 -->
                    <div class="img_box">
                        <div class="img_bu">
                            <img class="image" :src="imageUrl+license" />
                        </div>
                        <div class="img_tip">正面示例</div>
                    </div>
                    <van-uploader :after-read="onLienceRead" accept class="icon-add" ref="license">
                        <div class="addPhone"></div>
                    </van-uploader>
                </div>
            </div>
            <div class="item">
                <div class="title">上传身份证正反面照片</div>
                <div class="upload_images">
                    <!-- 示例图片 -->
                    <div class="img_box">
                        <div class="img_bu">
                            <img class="image" :src="imageUrl+legal_photo_facade" />
                        </div>
                        <div class="img_tip">正面示例</div>
                    </div>
                    <van-uploader :after-read="onFacadeRead" accept class="icon-add" ref="legal_photo_facade">
                        <div class="addPhone"></div>
                    </van-uploader>
                </div>
                <div class="upload_images">
                    <!-- 示例图片 -->
                    <div class="img_box">
                        <div class="img_bu">
                            <img class="image" :src="imageUrl+legal_photo_back" />
                        </div>
                        <div class="img_tip">反面示例</div>
                    </div>
                    <van-uploader :after-read="onBackRead" accept class="icon-add" ref="legal_photo_back">
                        <div class="addPhone"></div>
                    </van-uploader>
                </div>
            </div>
            <div class="item">
                <div class="title">姓名</div>
                <div class="name">
                    <van-field v-model="legal_person" placeholder="请填写您的真实姓名" />
                </div>
            </div>
            <div class="item">
                <div class="title">手机号</div>
                <div class="name">
                    <van-cell :title="phone" />
                </div>
            </div>

        </div>
        <!-- 协议 -->
        <div class="xieyi">
            <van-checkbox v-model="checked_xieyi">
                <template #icon="props">
                    <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                </template>
            </van-checkbox>
            <div class="tips">我已经阅读并同意<span class="xieyi_type" @click="goSinglePage(5)">“合伙人入驻协议”</span></div>
        </div>
        <!-- 入驻 -->
        <div class="big_btn" @click="applySeller">入驻</div>
    </div>
    <!-- 地区弹层 -->
    <van-popup v-model="areaPicker" position="bottom">
        <van-area :area-list="areaList" @confirm="confrimArea" @cancel="areaPicker=false" />
    </van-popup>
</div>
</template>

<script>
import Vue from 'vue';
import Field from 'vant';
import {
    Uploader
} from 'vant';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent
export default {
    data() {
        return {
            publicPath: process.env.BASE_URL,
            activeIcon: process.env.BASE_URL + 'statics/images/active.png',
            inactiveIcon: process.env.BASE_URL + 'statics/images/inactive.png',
            checked_xieyi: true,
            nickname: '',
            legal_person: '',
            phone: '',
            type: '1',
            street: '',
            area: '',
            area_name1: '1', //省
            area_name2: '2', //市
            area_name3: '3', //区
            areaList: {},
            areaPicker: false,
            token: '',
            legal_photo_facade: '/upload/20260323/20260323145608250.png', //身份证正面照片
            legal_photo_back: '/upload/20260323/20260323145637948.png', //身份证背面照片
            license: '/upload/20260323/20260323145520592.png', //营业执照
            intelligence: '', //资质证书
            company: '', //公司名
            companyCode: '', //企业机构代码
            imageUrl: Vue.prototype.$publicData.uploadImage,
        };
    },
    created: function () {
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            //设置导航栏
            var params = {
                'data': {
                    'naviTitle': '申请成为匠人'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {}
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getUserData()
                    this.getAreaData()
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
        } else {
            this.token = this.$store.getters.token
            this.getUserData()
            this.getAreaData()
        }
        console.log('this.addressId:' + this.addressId)
    },
    methods: {
        getUserData() {
            if (this.token == null) {
                return
            }
            var params = {
                token: this.token
            }
            this.$api.user.index(params).then(res => {
                if (res.code == 200) {
                    this.phone = res.result.info.users.username
                }
            })
        },
        getAreaData() {
            var params = {}
            this.$api.address.areaList(params).then(res => {
                if (res.code == 200) {
                    var area = JSON.parse(res.result)
                    this.areaList = area.areaList
                    console.log(this.areaList)
                } else {
                    this.$toast(res.message)
                }
            })
        },
        // 选角色 公司入驻还是个人入驻
        confrimRole(val) {
            console.log('val', val)
            this.role = val
            this.rolePicker = false
            if (this.role == '个人') {
                this.roleType = 0
            } else {
                this.roleType = 1
            }
        },
        // 选入驻身份
        confrimAgent(val) {
            this.agent = val
            this.agentPicker = false
        },
        // 确认选中地区
        confrimArea(data) {
            this.areaPicker = false;
            var area = ''
            for (let i = 0; i < data.length; i++) {
                const item = data[i];
                if (i == 0) {
                    this.area_name1 = item.code
                } else if (i == 1) {
                    this.area_name2 = item.code
                } else if (i == 2) {
                    this.area_name3 = item.code
                }
                area += item.name
            }
            this.area = area
        },
        // 图片身份证正面上传
        onFacadeRead: function (file) {
            this.$api.index.uploadImage({
                imgFile: file.content
            }).then(res => {
                if (res.code == 200) {
                    console.log("上传成功");
                    console.log(res);
                    this.legal_photo_facade = res.result.url;
                }
            });
        },
        // 图片身份证反面上传
        onBackRead: function (file) {
            this.$api.index.uploadImage({
                imgFile: file.content
            }).then(res => {
                if (res.code == 200) {
                    console.log("上传成功");
                    console.log(res);
                    this.legal_photo_back = res.result.url;
                }
            });
        },
        // 营业执照上传
        onLienceRead: function (file) {
            this.$api.index.uploadImage({
                imgFile: file.content
            }).then(res => {
                if (res.code == 200) {
                    console.log("上传成功");
                    console.log(res);
                    this.license = res.result.url;
                }
            });
        },
        applySeller() {
            if (this.area_name1 == null || this.area_name1 == undefined || this.area_name1 == '') {
                this.$toast('请选择收货人地区')
                return
            }
            var params = {
                token: this.token,
                area1: this.area_name1,
                area2: this.area_name2,
                area3: this.area_name3,
                describe: this.street,
                company: this.company,
                company_code: this.companyCode,
                legal_photo_facade: this.legal_photo_facade=='/upload/20260323/20260323145608250.png'?'':this.legal_photo_facade,
                legal_photo_back: this.legal_photo_back=='/upload/20260323/20260323145637948.png'?'':this.legal_photo_back,
                company_photo: this.license=='/upload/20260323/20260323145520592.png'?'':this.license,
                name: this.legal_person,
                phone: this.phone,
            }
            this.$api.my.partnerApply(params).then(res => {
                if (res.code == 200) {
					this.$toast(res.message)
					var that = this
					this.getApplyStatus(function(){
						if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
							//返回上级页面
							var params = {
								'data': {}
							}
							that.$bridge.callhandler('sdjy://public/back', params, (data) => {

							})
						} else {
							that.$router.back()
						}
					})
                } else {
                    this.$toast(res.message ? res.message : res.msg)
                }
            })

        },
        // 协议  1 平台服务协议;2 供应商入驻协议;3 匠人入驻协议; 4 帮助中心 ; 5合伙人入驻协议; 6 代理商入驻协议
        goSinglePage(id) {
            this.$router.push({
                path: '/single/page',
                query: {
                    id: id
                }
            })
        },
        // 获取申请角色的审核状态
        getApplyStatus(callback) {
            var params = {
                type: 4, // 1匠人2供应商3代理商4城市合伙人
                token: this.token
            }
            this.$api.my.roleStatus(params).then(res => {
                if (res.code == 200) {
                    //res.result 0认证中1认证通过2未通过3未申请
					localStorage.setItem('partner_apply_status', res.result)
					callback()
                }
            })
        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.page .upload-images {
    margin-top: .4rem;
}
</style>
